module.exports = __webpack_public_path__ + "img/logo-dhl.6cbb9f22.svg";